module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE S-30 TUBE AMPLIFIER.c3ddb54c.png";